module.exports = __webpack_public_path__ + "static/media/6.54e8755d.jpg";